<template lang="pug">
.facets(:class="{ ['facets-' + namespace]: true, collapsed: facetsCollapsed, 'for-folderlist': folderList }")
  .collapser(title="toggle tags", @click="toggle", v-if="namespace !== 'insightsNSNOT' && !lens")
  .top(:class="{ 'for-lens': lens }")
    .selected-filters(v-if="!lens", :class="{ empty: !Object.keys(selectedAllTags).length }")
      //.close(@click="clearFilters(true)")
      .filter.selected(v-for="(v, tag) in selectedAllTags",
                       @click="toggleTag(tag, true)",
                       :class="{ 'has-includes-excludes': Object.keys(selectedAllTags).length === 1 }")
        .includes-excludes(v-if="Object.keys(selectedAllTags).length === 1", @click.stop="andOr = andOr === 'nor' && 'and' || 'nor'",
                           :title="`switch to ${ andOr === 'nor' && 'includes' || 'excludes' }`") {{ andOr === 'nor' && 'excludes' || 'includes' }}
        .and-or(@click.stop="toggleAndOr()",
                :title="`switch to ${ andOr === 'and' && 'or' || andOr === 'or' && 'nor' || 'and' }`") {{ andOr }}
        .tag {{ tag }}
    button-tabs(v-if="!lens")
      //button-tab(:id="`${ namespace }/duration`", v-if="namespace === 'videosNS'")
      //  template(slot="title") duration
      //  template(slot="content")
      //    .reset(@click="reset('Duration')")
      //    .duration
      //      slider(v-model="duration",
      //             :interval="10",
      //             :max="50",
      //             :tooltip="'none'",
      //             :marks="true",
      //             :marksLabel="true",
      //             v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' } }")
      //      .info in minutes
      //button-tab(:id="`${ namespace }/age`")
      //  template(slot="title") age
      //  template(slot="content")
      //    .reset(@click="reset('Age')")
      //    .age
      //      slider(v-model="age",
      //             :max="5",
      //             :tooltip="'none'",
      //             :marks="true",
      //             :marksLabel="true",
      //             v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' } }")
      //      .info in {{ namespace === 'documentsNS' && 'quarters' || 'months' }}
      button-tab(:id="ns + 'sentiment'")
        template(slot="title") sentiment
        template(slot="content")
          .reset(@click="reset('Sentiment')")
          .sentiment
            slider(v-model="sentiment",
                   :max="6",
                   :tooltip="'none'",
                   :marks="true",
                   :marksLabel="true",
                   v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
      button-tab.button-tabs-volume(:id="ns + 'volume'", v-if="namespace === 'insightsNS'")
        template(slot="title") volume
        template(slot="content")
          .reset(@click="reset('Volume')")
          .volume
            .slider
              slider(v-model="volume",
                     :max="5",
                     :tooltip="'none'",
                     :marks="true",
                     :marksLabel="true",
                     v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
      button-tab.button-tabs-engagement(:id="ns + 'engagement'", v-else)
        template(slot="title") engagement
        template(slot="content")
          .reset(@click="reset('Engagement')")
          .engagement
            .interestingness(v-if="namespace !== 'insightsNS'")
              .slider
                slider(v-model="interestingness",
                       :max="6",
                       :tooltip="'none'",
                       :marks="true",
                       :marksLabel="true",
                       v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
            .visuality
              .slider
                slider(v-model="visuality",
                       :max="6",
                       :tooltip="'none'",
                       :marks="true",
                       :marksLabel="true",
                       v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
      //button-tab.right.button-tabs-sources(:id="`${ namespace }/source`")
      //  template(slot="title") sources
      //  template(slot="content")
      //    .reset(@click="reset('Source')")
      //    .source-popularity
      //      .slider
      //        slider(v-model="sourcePopularity",
      //               :max="5",
      //               :tooltip="'none'",
      //               :marks="true",
      //               :marksLabel="true",
      //               v-bind="{ lazy: true, enableCross: false, marksStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, marksActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
      //      .sources
      //        .items
      //          .item(v-for="{ info, count } in sourceIds",
      //                :class="{ selected: info.id in selectedSourceIds, empty: !count }"
      //                @click="selectSource(info.id)"
      //                :title="`${ info.name} - ${ count}`",
      //                :style="sourceStyle(info.url)")
    .checkboxes(v-if="!lens")
      checkbox.block(label="includes factoids", v-model="hasFactoids")
      checkbox.block(label="includes directives", v-model="hasDirectives")
    .collections(v-if="categories && namespace !== 'insightsNS' && !lens")
      multiselect(v-model="selectedCategories",
                  :options="categories",
                  :multiple="true",
                  :close-on-select="false",
                  :clear-on-select="false",
                  :preserve-search="true",
                  placeholder="Choose Categories"
                  selectLabel="+",
                  selectedLabel="\u2714",
                  deselectLabel="\u00D7")
        template(slot="selection"
                 slot-scope="{ values, search, isOpen }")
          span.multiselect__single(v-if="selectedCategories.length && !isOpen") {{ selectedCategories.length }} Categories
        template(slot="option", slot-scope="props")
          .option__desc
            span.option__title(NOTtitle="props.option.count") {{ props.option }}
          //pre.language-json
            code {{ value  }}
    .sectors(v-if="sectors && namespace !== 'insightsNS' && !lens")
      multiselect(v-model="selectedSectors",
                  :options="sectors",
                  :multiple="true",
                  :close-on-select="false",
                  :clear-on-select="false",
                  :preserve-search="true",
                  placeholder="Choose Sectors"
                  selectLabel="+",
                  selectedLabel="\u2714",
                  deselectLabel="\u00D7")
        template(slot="selection"
                 slot-scope="{ values, search, isOpen }")
          span.multiselect__single(v-if="selectedSectors.length && !isOpen") {{ selectedSectors.length }} Sectors
        template(slot="option", slot-scope="props")
          .option__desc
            span.option__title(NOTtitle="props.option.count") {{ props.option }}
          //pre.language-json
            code {{ value  }}
    //.tags(v-if="namespace === 'documentsNS' && types")
    //  multiselect(v-model="selectedTags",
    //              :options="allTags",
    //              :multiple="true",
    //              :close-on-select="false",
    //              :clear-on-select="false",
    //              :preserve-search="true",
    //              placeholder="Choose Tags"
    //              label="value",
    //              selectLabel="+",
    //              selectedLabel="\u2714",
    //              deselectLabel="\u00D7",
    //              track-by="value")
    //    template(slot="selection"
    //             slot-scope="{ values, search, isOpen }")
    //      span.multiselect__single(v-if="selectedTypes.length && !isOpen") {{ selectedTypes.length }} Types
    //    template(slot="option", slot-scope="props")
    //      .option__desc
    //        span.option__title(:title="props.option.count") {{ props.option.value }}
    //      //pre.language-json
    //        code {{ value  }}
  .themes-section(v-if="!ns && lens && !focusMode", :class="{ 'nudge-right': insightsShown }")
    .selected-themes
      .theme(v-for="{ t, n, th, id } in Object.keys(selectedThemes).map(n => ({...customThemes, ...themes })[n]).filter(t => t)",
        @click="toggleTheme(id || n)",
        :title="`Deselect ${ t || n }`",
        :name="(n.replace(/[^A-Z]/g, '') || n).trim().replace(/^(.{1,3}).*/, '$1')",
        :class="{ custom: id }")
        .details
          .close &times;
          .bg(v-if="th" :style="{ 'background-image': `url('${ th && th.url }')` }")
    .search
      label
        input(placeholder="filter", v-model="themesFilter")
        .close(v-if="themesFilter.trim().length", @click="themesFilter = ''") &times;
    .items
      .new-theme(title="add custom theme", @click="newTheme()", v-if="!folderList")
        .plus &plus; &nbsp;
        .text custom theme
      .custom-theme.theme(v-if="Object.keys(customThemes).length && !folderList",
                          @click="toggleTheme(ct.id)",
                          :class="{ selected: selectedThemes[ct.id] }",
                          v-for="ct in customThemes")
        .details
          .bg
            .actions
              .edit(@click.stop="updateTheme(ct)") edit
              .remove(@click.stop="removeTheme(ct.id)") delete
            .tags
              .tag(v-for="(value, tag) in ct.selectedTags",
                   @click.stop="toggleThemeTag({ customTheme: ct, tag })",
                   :title="`remove ${ tag }`") {{ tag }}
                .close &times;
          .title {{ ct.n }}
      .theme(v-for="({ t, n, count, th }, index) in filteredThemes",
             @click="toggleTheme(n)",
             :title="t || n",
             :class="{ selected: selectedThemes[n], hide: index > 40 }")
        .details
          .bg(:style="th && th.url && { 'background-image': `url('${ th.url }')` } || {}")
          .title {{ t || n }}
  .filters.vip(v-if="ns && upperTags && Object.keys(upperTags).length")
    .filter
      .tag Selected themes:
    .filter(v-for="(count, tag) in upperTags",
            @click="toggleTag(tag, true)"
            :class="{ empty: !proxyCount(tag), hasCount: proxyCount(tag) > 1, selected: ns ? selected(tag) : selectedAllTags[tag] }")
      .tag(:count="proxyCount(tag)") {{ tag }}
      .count(v-if="proxyCount(tag) > 1") &mdash; {{ proxyCount(tag) }}
  .filters(:class="{ collapse }", v-if="!lens")
    .filter-filters
      .clearer(:class="{ hidden: !q }", @click="q = ''")
      input(v-model="q", placeholder="filter")
    .filter(v-for="([tag, count]) in allTags",
            v-show="testWord(tag)",
            @click="toggleTag(tag, true)"
            :class="{ empty: !count, hasCount: count > 1, selected: ns ? selected(tag) : selectedAllTags[tag] }")
      .tag(:count="count") {{ tag }}
      .count(v-if="count > 1") &mdash; {{ count }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed, vuexComputedNamespace } from '@/helpers';
import vueSliderComponent from 'vue-slider-component';
import multiselect from 'vue-multiselect';
import buttonTabs from './button-tabs';
import buttonTab from './button-tab';
import checkbox from './checkbox';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  name: 'facets',
  props: {
    namespace: { type: String, default: '' }
  },
  computed: {
    ...mapGetters(['collapse', 'customThemes', 'folderList', 'focusMode']),
    ...vuexComputed(
      'themes',
      'selectedThemes',
      'lens',
      'insightsShown',
      'themesFilter',
      'facetsCollapsed' //,
      //'allTags',
      //'selectedAllTags' //,
      // 'sectors',
      // 'selectedSectors',
      // 'categories',
      // 'selectedCategories',
      // 'sentiment',
      // 'interestingness',
      // 'visuality'
    ),
    ...vuexComputedNamespace(
      'facetsCollapsed',
      'tags',
      'selectedTags',
      'sectors',
      'selectedSectors',
      // 'types',
      // 'selectedTypes',
      'categories',
      'selectedCategories',
      // 'sourceIds',
      // 'selectedSourceIds',
      // 'duration',
      // 'age',
      'sentiment',
      'interestingness',
      'visuality',
      'sourcePopularity',
      'volume',
      'tagsForGrid',
      'andOr',
      'hasFactoids',
      'hasDirectives'
    ),
    ns() {
      const { namespace } = this;
      return (namespace && namespace + '/') || '';
    },
    allTags() {
      const { key, $store } = this;
      return $store.getters[key('tagsForGrid', 'allTags')];
    },
    selectedAllTags() {
      const { key, $store } = this;
      return $store.getters[key('selectedTags', 'selectedAllTags')];
      // return $store.getters[key('selectedTagsForGrid', 'selectedAllTags')];
    },
    upperTags() {
      return this.$store.getters.selectedAllTags;
    },
    aliases() {
      const {
        $store: {
          getters: { aliases }
        },
        allTags: items
      } = this;
      //return { ...aliases, ...Object.entries(items).reduce((all, [tag]) => ({ ...all, [tag]: aliases[tag] || tag.toLowerCase() }), {}) };
      return {
        ...aliases,
        ...Object.entries(items).reduce((all, [tag]) => {
          all[tag] = aliases[tag] || tag; //.toLowerCase();
          return all;
        }, {})
      };
    },
    q: {
      get() {
        const {
          ns,
          $store: { getters }
        } = this;
        return getters[ns + 'q'];
      },
      set(value) {
        const {
          ns,
          $store: { dispatch }
        } = this;
        return dispatch(ns + 'q', value);
      }
    },
    qs() {
      return this.q?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
    },
    filteredThemes() {
      const { themesFilter, themes, focusMode } = this;
      //console.log('filtering themes in facets', themes);
      //console.log('thms2', Object.values(themes).map(({ t, c }) => `${ t }: ${ c }`).join(', '));
      const filters = themesFilter?.split(/\s+/).map(item => new RegExp(item.toLowerCase().replace(/\W/g, '.'), 'i'));
      return Object.values(themes || {})?.filter(({ k, t, a }) => !a && filters?.every(filter => filter.test((k || [t]).join('|') + '|' + t))).sort((a, b) => b.c - a.c);
    }
  },
  methods: {
    ...mapActions(['toggleTheme', 'editTheme', 'removeTheme', 'toggleThemeTag']),
    async updateTheme(nt) {
      return await this.newTheme(nt);
    },
    async newTheme(nt) {
      //showModalFacets
      let id = nt?.id;
      nt = nt || {
        n: '',
        selectedTags: {},
        tags: this.allTags,
        andOr: 'and'
      };
      await this.$store.dispatch('newTheme', nt);
      await this.editTheme(nt);
      if (!id) {
        id = (await this.$store.getters['newTheme']).id;
        await this.$store.dispatch('toggleTheme', id);
      }
    },
    key(nsProp, prop) {
      const { ns } = this;
      return (ns && ns + nsProp) || prop;
    },
    async toggleTag(tag) {
      const { ns } = this;
      await this.$store.dispatch(ns + 'toggleTag', tag);
    },
    async selectSource(tag) {
      await this.$store.dispatch(this.namespace + '/selectSource', tag);
    },
    selected(tag) {
      return this.selectedTags[tag];
    },
    clearFilters(video) {
      console.log('clearFilters', video, ((video && 'video') || 'tweet') + 'Filters');
      this.store.dispatch(((video && 'video') || 'tweet') + 'Filters', {});
    },
    sourceStyle(url) {
      const r = {};
      if (url) {
        r['background-image'] = `url('${ url }')`;
      }
      return r;
    },
    reset(type) {
      const {
        $store: { dispatch },
        ns
      } = this;
      dispatch(`${ ns }reset${ type }`);
    },
    styleBySourceId(source) {
      const r = {};
      const { info } = this.sourceIds?.filter(({ info: { id } }) => id === source).pop() || {};
      if (source && info?.url) {
        r['background-image'] = `url('${ info.url }')`;
      }
      return r;
    },
    toggle() {
      this.facetsCollapsed = !this.facetsCollapsed;
      //this.hub.$emit('facet-collapse');
    },
    toggleAndOr() {
      const { andOr } = this;
      this.andOr = { and: 'or', or: 'nor', nor: 'and' }[andOr];
    },
    proxyCount(tag) {
      return valueFromEntries(this.tagsForGrid, tag) || 0;
      // return this.allTags[tag]?.count || 0;
      function valueFromEntries(entries, key) {
        return entries?.filter(([k]) => k === key)[0]?.[1];
      }
    },
    testWord(word) {
      const { qs, aliases, selectedAllTags } = this;
      const { [word]: alias } = aliases;
      /*console.log(qs.join('|'), word, qs.reduce((hit, item) => {
        return hit && item.test(alias || word);
      }, true));*/
      return (
        !qs.length ||
        // to fix dead end bug: force any selected tag to show
        selectedAllTags[word] ||
        qs.reduce((hit, item) => {
          return hit && item.test(alias || word);
        }, true)
      );
    }
  },
  components: { slider: vueSliderComponent, multiselect, buttonTabs, buttonTab, checkbox }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.facets {
  position: relative;
  display: none;
  &.for-folderlist {
    margin-top: -1.5rem;
  }
  .filter-filters {
    position: relative;
    display: flex;
    padding-left: 1rem;
    input:focus {
      outline: none;
    }
  }
  @include large {
    display: block;
    &.facets-videosNS {
      .top {
        grid-template-columns: auto 23.9rem 15% 15% 1.5%;
      }
    }
    &.facets-documentsNS {
      .top {
        grid-template-columns: auto 25.2rem 15% 15% 15% 1.5%;
      }
    }
    &.facets-insightsNS {
      .top {
        //grid-template-columns: auto 10.5rem 17.75rem 15% 15% 1.5%;
        grid-template-columns: auto 17.75rem 10.5rem 15% 1.5%;
        .checkboxes {
          display: block;
          padding: 1rem 0.5rem;
          margin-right: 0.5rem;
          margin-bottom: -1.7rem;
        }
      }
    }
    &.collapsed {
      .filters:not(.vip) {
        overflow: hidden;
        min-height: 0;
        max-height: 0.25rem;
        padding: 0;
        .filter {
          transition-delay: 0;
          opacity: 0;
        }
      }
      .collapser {
        &::after {
          transform: rotate(90deg) translate3d(1rem, -0.75rem, 0);
        }
      }
      .filter-filters {
        visibility: hidden;
      }
    }
    .collapser {
      cursor: pointer;
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 1;
      &::after {
        color: #777;
        display: inline-block;
        width: 2rem;
        height: 2rem;
        content: '\BB';
        font-size: 2rem;
        transform-origin: center;
        transform: rotate(-90deg);
      }
      transform: translate3d(-2.5rem, 1rem, 0);
    }
    .top {
      padding-bottom: 1rem;
      display: grid;
      grid-template-columns: auto 17.75rem 15% 15% 1.5%;
      border-bottom: 1px solid $brn;
      &.for-lens {
        margin-bottom: 1rem;
      }
      .checkboxes {
        display: none;
      }
      .collections {
        padding-top: 0.7rem;
      }
      .sectors {
        padding-top: 0.7rem;
      }
      .types {
        padding-top: 0.7rem;
      }
      .info {
        position: relative;
        top: 0.5rem;
        font-style: italic;
        color: #aaa;
        text-align: right;
      }
    }
  }
  .selected-filters,
  .filters {
    display: none;
    @include large {
      //height: auto;
      //max-height: 100vh;
      overflow: auto;
      display: grid;
      grid-template-rows: 100%;
      grid-gap: 2%;
      grid-row-gap: 2%;
      grid-auto-columns: 14%;
      grid-auto-flow: column;
      padding-bottom: 1.2rem;
      &.selected-filters {
        width: 100%;
        display: flex;
        padding: 0.7rem 0.25rem;
        min-height: 2rem;
        max-height: 1.2rem;
        overflow: hidden;
        position: relative;
        &.empty {
          opacity: 0;
        }
        .close {
          height: 3rem;
          width: 3rem;
          &:hover {
            &::after {
              color: black;
            }
          }
          &::after {
            color: #dadada;
            cursor: pointer;
            content: '\D7';
            position: absolute;
            top: -50%;
            right: 0.3rem;
            font-size: 2rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -70%, 0);
          }
        }
        .filter {
          max-width: 14%;
          margin-right: 0.25rem;
          background-color: $brn;
          color: white;
          position: relative;
          margin-top: 0.35rem;
          padding-left: 0.25rem;
          padding-right: 0.8rem;
          max-height: 1.2rem;
          &::after {
            content: '\00d7';
            position: absolute;
            top: 50%;
            right: 0.3rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -50%, 0);
          }
          .and-or {
            display: none;
          }
          .includes-excludes {
            display: none;
          }
          &.has-includes-excludes:first-child {
            position: relative;
            margin-left: 5rem;
            .includes-excludes {
              width: 4.6rem;
              // outline: 1px solid green;
              text-align: center;
              color: #555;
              display: block;
              position: absolute;
              left: -4.5rem;
              cursor: pointer;
              &:hover {
                color: black;
              }
            }
          }
          &:not(:first-child) {
            position: relative;
            margin-left: 2.5rem;
            .and-or {
              width: 1.6rem;
              // outline: 1px solid green;
              text-align: center;
              color: #555;
              display: block;
              position: absolute;
              left: -2.25rem;
              cursor: pointer;
              &:hover {
                color: black;
              }
            }
          }
        }
        .sources {
          margin-left: 1rem;
          display: flex;
          .source {
            cursor: pointer;
            border-radius: 4px;
            margin-top: 0.3rem;
            margin-right: 0.2rem;
            width: 1.9rem;
            height: 1.9rem;
            background: no-repeat center;
            background-size: contain;
            position: relative;
            &:hover {
              &::after {
                box-sizing: border-box;
                //padding-top: 0.2rem;
                text-align: center;
                font-size: 2rem;
                color: white;
                text-shadow: 0 0 2px black;
                content: '\D7';
                position: absolute;
                top: -0.4rem;
                left: 0;
                bottom: 0.4rem;
                right: 0;
              }
            }
          }
        }
      }
    }
    &.filters.collapse {
      .filter.empty {
        display: none;
      }
    }
    .filter {
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 3px;
      padding: 0.25rem 0.5rem 0.25rem 1rem;
      display: flex;
      margin: 0.125rem 0;
      margin-bottom: -0.25rem;
      white-space: nowrap;
      transition: opacity 200ms ease-in-out 200ms;
      &.selected {
        border-color: $brn;
        .tag[count='0'] {
          opacity: 1;
        }
      }
      .tag {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 0.25rem;
        &[count='0'] {
          opacity: 0.25;
        }
      }
      &.has-count {
        .tag {
          max-width: 80%;
        }
      }
      .count {
        color: #9a9a9a;
      }
    }
  }
  .themes-section {
    position: relative;
    box-sizing: border-box;
    //padding-top: 1.25rem;
    transition: all 250ms ease-in-out;
    &.nudge-right {
      max-width: 79vw;
      .search {
        transform: translate3d(21vw, 0, 0);
      }
      .items {
        margin-left: 21vw;
        width: 79vw;
      }
      .selected-themes {
        transform: translate3d(21vw, 0, 0);
      }
    }
    .selected-themes {
      height: 4.7rem;
      margin-bottom: 1.25rem;
      display: flex;
      justify-content: flex-start;
      transform: translate3d(0, 0, 0);
      transition: transform 250ms ease-in-out;
      will-change: transform;
      padding-left: 2rem;
      .theme {
        cursor: pointer;
        width: 3rem;
        flex: 0 0 auto;
        border: 3px solid transparent;
        box-sizing: border-box;
        //padding-bottom: 0.5rem;
        margin: 0.25rem;
        position: relative;
        &:hover {
          .details {
            .close {
              opacity: 1;
            }
          }
        }
        &.hide {
          display: none;
        }
        &.custom {
          border-color: #ccc;
          &::after {
            content: attr(name);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);
          }
        }
        //padding: 0.25rem;
        .details {
          position: relative;
          .close {
            position: absolute;
            top: -0.2rem;
            right: 0.125rem;
            color: white;
            text-shadow: 1px 1px 0 black, -1px -1px 0 black, 0 1px 0 black, 1px 0 0 black, 0 -1px 0 black,
            -1px 0 0 black, 1px 1px 1px black, -1px -1px 1px black, 0 1px 1px black, 1px 0 1px black,
            0 -1px 1px black, -1px 0 1px black;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
            will-change: opacity;
          }
          .title {
            white-space: nowrap;
            overflow:  hidden;
            text-overflow: ellipsis;
          }
          .bg {
            width: 100%;
            padding-top: 145%;
            background: no-repeat top center;
            background-size: cover;
          }
        }
      }
    }
    .search {
      position: absolute;
      top: 4.75rem;
      left: 0.4rem;
      transform: translate3d(0, 0, 0);
      will-change: transform;
      transition: transform 250ms ease-in-out;
      label {
        position: relative;
        input {
          &:focus {
            outline: none;
          }
          padding-right: 1rem;
        }
      }
      .close {
        position: absolute;
        top: 0;
        right: 0.5rem;
        cursor: pointer;
      }
    }
    .items {
      width: 100vw;
      overflow: auto;
      display: flex;
      justify-content: flex-start;
      transition: all 250ms ease-in-out;
      box-sizing: border-box;
      //padding-left: 3rem;
      position: relative;
      &.alt {
        position: relative;
        /*padding-left: 16rem;*/
        /*display: grid;*/
        /*grid-template-rows: 1fr 1fr;*/
        /*grid-template-columns: repeat(7, 1fr);*/
        .theme {
          width: 3rem;
          /*transform: scale(0.35);*/
          margin: 0;
          margin-right: 0.125rem;
          /*&:nth-child(1),
          &:nth-child(2) {
            position: absolute;
            top: 0;
            left: 0;
            transform: scale(1);
            &:nth-child(2) {
              left: 8rem;
            }
          }*/
        }
      }
      &.NOTalt {
        position: relative;
        padding-left: 16rem;
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: repeat(7, 1fr);
        .theme {
          transform: scale(0.35);
          margin: -10rem;
          &:nth-child(1),
          &:nth-child(2) {
            position: absolute;
            top: 0;
            left: 0;
            transform: scale(1);
            &:nth-child(2) {
              left: 8rem;
            }
          }
        }
      }
      .new-theme {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        font-weight: bold;
        color: orange;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid orange;
        padding: 0.5rem 1rem;
        transform: translate3d(-3rem, 4.1rem, 0) rotate(-90deg);
        transition: all 250ms ease-in-out;
        &:hover {
          background-color: orange;
          color: white;
        }
        .text {
          white-space: nowrap;
        }
      }
      .theme {
        width: 11rem;
        flex: 0 0 auto;
        border: 3px solid transparent;
        box-sizing: border-box;
        padding-bottom: 0.5rem;
        margin: 0.25rem 0.25rem 1.5rem;
        //padding: 0.25rem;
        &.selected {
          border-color: orange;
          .bg {
          }
        }
        &.custom-theme {
          .bg {
            background-color: #f8f8f8;
            .tags {
              position: absolute;
              top: 3.5rem;
              left: 0.65rem;
              bottom: 0.65rem;
              right: 0.65rem;
              padding: 0.25rem;
              border: 1px solid #dfdfdf;
              background-color: white;
              & > .tag {
                cursor: pointer;
                float: left;
                background-color: $brn;
                color: white;
                position: relative;
                box-sizing: border-box;
                border-radius: 0.125rem;
                margin-top: 0.35rem;
                padding-left: 0.25rem;
                padding-right: 0.9rem;
                max-height: 1.2rem;
                max-width: 90%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-right: 0.25rem;
                &:hover {
                  .close {
                    opacity: 1;
                  }
                }
                .close {
                  position: absolute;
                  top: -0.1rem;
                  right: 0.25rem;
                  opacity: 0;
                }
              }
            }
          }
        }
        .bg {
          width: 100%;
          padding-top: 145%;
          background: no-repeat top center;
          background-size: cover;
          position: relative;
          &:hover {
            .actions {
              pointer-events: all;
              opacity: 1;
            }
          }
          .actions {
            position: absolute;
            top: 1.25rem;
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            opacity: 0;
            will-change: opacity;
            transition: opacity 300ms ease-in-out;
            pointer-events: none;
            & > * {
              cursor: pointer;
              user-select: none;
              border: 1px solid #dfdfdf;
              padding: 0.25rem 0.5rem;
              border-radius: 0.125rem;
              font-size: 0.8rem;
              background-color: white;
              color: $brn;
              text-transform: uppercase;
              &:hover {
                border-color: $brn;
              }
            }
          }
        }
        .title {
          white-space: nowrap;
          overflow:  hidden;
          text-overflow: ellipsis;
          margin-top: 0.5rem;
          font-size: 0.9rem;
        }
      }
    }
  }
  .filters {
    &.vip {
      grid-template-rows: 100% !important;
      min-height: 1.5rem !important;
      .filter .tag {
        min-height: 1.2rem;
      }
    }
    @include large {
      height: auto;
      position: relative;
      top: 0.4rem;
      padding-bottom: 2rem;
      grid-auto-columns: 20%;
      //grid-template-rows: repeat(7, 14%);
      grid-template-rows: repeat(5, 20%);
      //min-height: 12rem;
      min-height: 8.5rem;
      transition: all 400ms ease-in-out;
    }
  }
}
</style>
<style lang="scss">
// .option__title in vue multiselect, add overflow ellipsis
/*.option__title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }*/
.tab-content {
  &.modified {
    .reset {
      opacity: 1;
      z-index: 1;
    }
  }
  .reset {
    position: absolute;
    top: 1rem;
    right: 1rem;
    opacity: 0;
    z-index: -1;
    transition: opacity 400ms ease-in-out;
    will-change: opacity;
    &::after {
      cursor: pointer;
      font-size: 0.8rem;
      color: #777;
      content: 'reset';
    }
    &:hover::after {
      color: black;
    }
  }
}
.vue-slider-mark {
  &:first-of-type,
  &:last-of-type {
    &::after {
      white-space: nowrap;
      font-size: 0.7rem;
      color: #777;
      position: absolute;
      top: 240%;
      left: 180%;
    }
    &:last-of-type {
      &::after {
        content: '+';
      }
    }
  }
}
.age {
  .vue-slider-mark:last-of-type {
    &::after {
      content: '+';
    }
  }
}
.sentiment {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -1rem;
        color: #555;
        content: 'negative';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -1rem;
        color: #555;
        content: 'positive';
      }
    }
  }
}
.interestingness {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        content: 'interesting';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.visuality {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        margin-left: 0.65rem;
        content: 'visual';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.volume {
  .vue-slider.vue-slider-ltr .vue-slider-mark {
    &:first-of-type {
      color: transparent !important;
      background-color: orange;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'less';
      }
    }
    &:nth-of-type(3) {
      color: transparent !important;
      &::after {
        position: absolute;
        top: 240%;
        white-space: nowrap;
        font-size: 0.7rem;
        color: #555;
        left: 50%;
        margin-left: 0.65rem;
        content: '';
      }
    }
    &:last-of-type {
      color: transparent !important;
      &::after {
        left: -0.5rem;
        color: #555;
        content: 'more';
      }
    }
  }
}
.source-popularity {
  .slider {
    margin-left: 3rem;
    width: 20rem;
  }
  .vue-slider.vue-slider-ltr {
    .vue-slider-mark {
      &:first-of-type {
        color: transparent !important;
        background-color: orange;
        &::after {
          left: -0.5rem;
          color: #555;
          content: 'less';
        }
      }
      &:nth-of-type(3) {
        color: transparent !important;
        &::after {
          position: absolute;
          top: 240%;
          white-space: nowrap;
          font-size: 0.7rem;
          color: #555;
          left: 50%;
          content: 'popularity';
        }
      }
      &:last-of-type {
        color: transparent !important;
        &::after {
          left: -0.5rem;
          color: #555;
          content: 'more';
        }
      }
    }
  }
}
.button-tab {
  &.button-tabs-sources {
    .tab-content {
      width: 44rem;
    }
  }
  .tab-content {
    .sources {
      box-sizing: border-box;
      padding-top: 0.5rem;
      padding-bottom: 1rem;
      max-height: 70vh;
      overflow: auto;
      .items {
        margin-left: 2.25rem;
        display: grid;
        grid-gap: 0.8rem 0.1rem;
        grid-template-columns: repeat(10, 9.5%);
        .item {
          margin: -3px;
          width: 2.5rem;
          height: 2.5rem;
          background: no-repeat center;
          background-size: contain;
          border: 6px solid transparent;
          border-radius: 3px;
          position: relative;
          &.selected {
            border-color: orange;
            box-shadow: 0 0 2px black;
          }
          &.empty {
            opacity: 0.3;
            overflow: hidden;
            border-color: #dadada;
            &::before {
              content: '\00a0';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
            }
            &::after {
              content: '\00a0';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              /*background-color: rgba(255, 165, 0, 0.5);*/
              /*outline: 3px dashed rgba(255, 165, 0, 0.5);*/
            }
          }
        }
      }
    }
  }
}
</style>
